import { useEffect, useState } from 'react';
import './WalletsPage.css';
import { removeWallet, userStatistics } from '../../utils/api';
import { useUI } from '../../hooks/useUI';
import Navigation from '../Navigation/Navigation';
import WalletItem from '../WalletItem/WalletItem';
import ModalWindow from '../ModalWindow/ModalWindow';
import AddWallet from '../AddWallet/AddWallet';
import { resources } from '../../utils/resources';

const WalletsPage = ({ user }) => {
    const { isModalOpen, openModal, selectedWallet, setSelectedWallet, setUserData, userData, setSubmitBtnState } = useUI();
    const [modalCloseCount, setModalCloseCount] = useState(0);

    useEffect(() => {
        if (user?.user_wallets && user.user_wallets.length > 0) {
            const savedWallet = selectedWallet;
            const walletExists = savedWallet && user.user_wallets.some(
                (wallet) => wallet.wallet_id === savedWallet.wallet_id
            );

            if (!walletExists) {
                const firstWallet = user.user_wallets[0];
                setSelectedWallet(firstWallet);
                console.log('Selected first wallet:', firstWallet);
            }
        } else {
            setSelectedWallet(null);
            openModal();
        }
    }, [user, selectedWallet, setSelectedWallet, openModal]);

    const handleSelectWallet = (wallet) => {
        setSelectedWallet(wallet);
        console.log('Selected wallet:', wallet);
    };

    const handleDeleteWallet = async (wallet) => {
        try {
            const response = await removeWallet(window.Telegram.WebApp.initData, wallet.wallet_id);
            console.log(`Wallet ${wallet.wallet_id} removed:`, response);

            const responseStats = await userStatistics(window.Telegram.WebApp.initData);
            const updatedUser = responseStats.result;
            setUserData(updatedUser);
            console.log('Updated user data:', updatedUser);

            if (selectedWallet?.wallet_id === wallet.wallet_id) {
                const newSelectedWallet = updatedUser.user_wallets?.[0] || null;
                setSelectedWallet(newSelectedWallet);
                console.log('New selected wallet:', newSelectedWallet);
            }
        } catch (error) {
            console.error('Error removing wallet:', error);
            alert('Failed to remove wallet. Please try again.');
        }
    };

    const openModalFunc = () => {
        setSubmitBtnState(true);
        openModal();
    };

    const handleModalClose = () => {
        // Откладываем увеличение счётчика на 1 секунду, чтобы анимация завершилась
        setTimeout(() => {
            setModalCloseCount((prev) => prev + 1);
        }, 1000); // Длительность анимации — 1 секунда
    };

    return (
        <div className='walletsPage' style={{ backgroundImage: `url(${resources.images.bgLight})` }}>
            <div className="container">
                <div className="walletsPage__top">
                    <div className='walletsPage__title appearanceAnimation'>Wallets</div>
                    <div className="walletsPage__quantity appearanceAnimation">
                        {user?.user_wallets ? `${user.user_wallets.length}/999` : '0/999'}
                    </div>
                    <button className='walletsPage__btnAdd' onClick={() => openModalFunc()}>Add</button>
                </div>
                <div className="walletsPage__list">
                    {user?.user_wallets && user.user_wallets.length > 0 ? (
                        user.user_wallets.map((wallet) => (
                            <WalletItem
                                key={wallet.wallet_id}
                                active={selectedWallet?.wallet_id === wallet.wallet_id}
                                value={wallet.wallet_public_key}
                                onClick={() => handleSelectWallet(wallet)}
                                onDelete={() => handleDeleteWallet(wallet)}
                            />
                        ))
                    ) : (
                        <div className="walletsPage__empty"></div>
                    )}
                </div>
            </div>
            <Navigation />
            <ModalWindow
                key={`modal-window-${modalCloseCount}`}
                title="Add wallet"
                content={<AddWallet />}
                onClose={handleModalClose}
            />
        </div>
    );
};

export default WalletsPage;